import React, { useEffect, useState } from "react";
import WisdomLogo from "../image/logo/appLogo.png";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Alert,
  AlertColor,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Typography,
} from "@mui/material";
import AdminLoader from "./AdminLoader";
import OnboardingLayout from "./Layout/OnboardingLayout";
import MWTextField from "../component/MWTextField";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../redux/store/Store";
import { clearLoginAPIRes, jwtTokenApiCall } from "../redux/jwtAdminLogIn/API";
import { JwtTokenAuthBody } from "../redux/jwtAdminLogIn/Model";
import {
  adminLoginDetailsApi,
  clearGetAdminDetailsAPIRes,
} from "../redux/jwtAdminLogIn/adminLoginDetails/API";
import { LoginBody } from "../redux/jwtAdminLogIn/adminLoginDetails/Model";
import MWSnackbar from "../component/MWSnackbar";

export default function Login() {
  const dispatch = useDispatch();
  const { t } = useTranslation(["home"]);
  const [isLoading, setIsLoading] = useState(false);
  const loadingMarkup = isLoading ? <AdminLoader /> : null;
  const apiAuthTokenValue = useSelector(
    (state: AppState) => state.apiAuthToken
  );
  const adminLoginDetailsResponse = useSelector(
    (state: AppState) => state.adminLoginDetailsRes
  );
  const [apiMsgType, setAPIMsgType] = useState<AlertColor>("success");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const keyDownEvent = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };
  const [email, setEmail] = React.useState("");
  const [errorEmail, setErrorEmail] = useState("");
  interface State {
    password: string;
    showPassword: boolean;
  }

  const [password, setPassword] = React.useState<State>({
    password: "",
    showPassword: false,
  });

  const handleChange =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setPassword({ ...password, [prop]: event.target.value });
    };

  const handleClickShowPassword = () => {
    setPassword({ ...password, showPassword: !password.showPassword });
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  const [errorpassword, setErrorPassword] = useState("");
  const errorPassword = errorpassword ? (
    <Typography color="#de5555">{errorpassword}</Typography>
  ) : (
    ""
  );

  const authApiBody = {
    username: email.toLowerCase(),
    password: password.password,
  } as JwtTokenAuthBody;

  // initiate Login API
  const handleLogin = () => {
    if (email === "" && password.password === "") {
      setErrorEmail(`${t("common.erroremail", { ns: ["home"] })}`);
      setErrorPassword(`${t("home.enterpassword", { ns: ["home"] })}`);
    } else if (email === "" && password.password !== "") {
      setErrorEmail(`${t("common.erroremail", { ns: ["home"] })}`);
      setErrorPassword("");
    } else if (email !== "" && password.password === "") {
      setErrorEmail("");
      setErrorPassword(`${t("home.enterpassword", { ns: ["home"] })}`);
    } else {
      setError("");
      setErrorEmail("");
      setErrorPassword("");
      dispatch(clearLoginAPIRes());
      dispatch(clearGetAdminDetailsAPIRes());
      setError("");
      dispatch(jwtTokenApiCall(authApiBody));
    }
  };
  const [access, setToken] = useState("");
  useEffect(() => {
    if (apiAuthTokenValue?.loginRes?.access !== undefined) {
      setToken(apiAuthTokenValue?.loginRes?.access);
    }

    if (apiAuthTokenValue?.errorMsg !== "") {
      setAPIMsgType("error");
      setError(`${t("common.apitokenerror", { ns: ["home"] })}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiAuthTokenValue]);

  useEffect(() => {
    if (access !== "") {
      dispatch(
        adminLoginDetailsApi({
          access: access,
        } as LoginBody)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access]);

  useEffect(() => {
    setIsLoading(adminLoginDetailsResponse?.loading);
    if (
      adminLoginDetailsResponse?.getAdminLoginDetailsRes?.user?.id !== undefined
    ) {
      window.location.reload();
      setAPIMsgType("success");
      setSuccess(`${t("common.loginsuccess", { ns: ["home"] })}`);
    }
    if (adminLoginDetailsResponse?.errorMsg !== "") {
      setError(adminLoginDetailsResponse?.errorMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminLoginDetailsResponse]);
  const alertCloseAction = (alertState: boolean) => {
    if (alertState) {
      dispatch(clearGetAdminDetailsAPIRes());
    }
  };

  const actualPageMarkup = (
    <Grid
      container
      direction="row"
      justifyContent="space-evenly"
      alignItems="center"
    >
      <Grid item>
        <Box>
          {loadingMarkup}
          <Card sx={{ minWidth: 420 }}>
            <CardContent>
              <Box sx={{ m: 2 }} onKeyDown={keyDownEvent}>
                <img src={WisdomLogo} alt="Logo" height="50" />
                <Box mt={2}>
                  <Typography variant="h6" gutterBottom>
                    {t("home.welcome", { ns: ["home"] })}
                  </Typography>
                </Box>
                <MWTextField
                  fullWidth
                  sx={{ my: 2 }}
                  size="small"
                  value={email}
                  error={errorEmail === "" ? false : true}
                  label={t("common.emailorphno", { ns: ["home"] })}
                  placeholder={t("common.emailorphno", { ns: ["home"] })!}
                  id="emailFieldID"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setEmail(event.target.value);
                    setErrorEmail("");
                  }}
                  helperText={
                    errorEmail === "" ? (
                      <Box>
                        {t("common.emailHelperText", { ns: ["home"] })!}
                      </Box>
                    ) : (
                      errorEmail
                    )
                  }
                  InputLabelProps={{ shrink: true }} 
                />
                <FormControl fullWidth variant="outlined">
                  <InputLabel
                    size="small"
                    htmlFor="outlined-adornment-password"
                    shrink
                  >
                    {t("home.enterpassword", { ns: ["home"] })!}
                  </InputLabel>
                  <OutlinedInput
                  notched
                    id="outlined-adornment-password"
                    size="small"
                    error={errorPassword === "" ? false : true}
                    placeholder={t("home.enterpassword", { ns: ["home"] })!}
                    label={t("home.enterpassword", { ns: ["home"] })!}
                    type={password.showPassword ? "text" : "Password"}
                    value={password.password}
                    onChange={handleChange("password")}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          size="small"
                        >
                          {password.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <FormHelperText>
                    <Grid
                      container
                      item
                      direction="column"
                      justifyContent="center"
                      xs={12}
                    >
                      <Grid
                        container
                        item
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-start"
                      >
                        <Box>
                          {errorPassword === "" ? (
                            <Box>
                              {
                                t("common.passwordHelperText", {
                                  ns: ["home"],
                                })!
                              }
                            </Box>
                          ) : (
                            errorPassword
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </FormHelperText>
                </FormControl>
                <Box>
                  <Button
                    sx={{ my: 2 }}
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleLogin}
                  >
                    {t("common.login", { ns: ["home"] })!}
                  </Button>
                </Box>
                {error !== "" ? (
                  <Box>
                    <Alert
                      severity={apiMsgType}
                      onClose={() => {
                        dispatch(clearLoginAPIRes());
                        dispatch(clearGetAdminDetailsAPIRes());
                        setError("");
                      }}
                    >
                      {error}
                    </Alert>
                  </Box>
                ) : null}
                <MWSnackbar
                  msg={success}
                  type={apiMsgType}
                  alertClose={alertCloseAction}
                />
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Grid>
    </Grid>
  );
  return (
    <Box>
      <Container maxWidth="xl">
        <OnboardingLayout>{actualPageMarkup}</OnboardingLayout>
      </Container>
    </Box>
  );
}
